import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { PayloadStates } from '@lore/utils';
import Loader from '../../../components/Loader';
import useProjectTags from '../../../hooks/useProjectTags';
import TagTypes from '../../../constants/TagTypes';
import useTags from '../../../hooks/useTags';
import TextContentSection from '../../../components_profiles/TextContentSection';

Subjects.propTypes = {
  project: PropTypes.object.isRequired
};

export default function Subjects(props) {
  const { project } = props;

  const subjects = useTags(TagTypes.Subject);
  const projectSubjects = useProjectTags(project, TagTypes.Subject);

  if (projectSubjects.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  return (
    <TextContentSection title="Related subject areas">
      <ul className="list-disc ml-6">
        {subjects.data.map(function(subject) {
          const projectSubject = _.find(projectSubjects.data, function(projectSubject) {
            return projectSubject._tag.id === subject.id;
          });

          if (!projectSubject) {
            return null;
          }

          return (
            <li key={subject.id || subject.cid}>
              {subject.data.name}
            </li>
          );
        })}
      </ul>
    </TextContentSection>
  );
};
